import { useState } from 'react';

export default function DepositoFirme({ desafio, servicios, onPagar, onVolver }) {
  const [pagando, setPagando] = useState(false);
  const [pagado,  setPagado]  = useState(false);

  const precioCancha  = desafio.cancha?.precio || 28000;
  const precioArbitro = desafio.conArbitro && desafio.arbitro
    ? desafio.arbitro.tarifa : 0;
  const margen   = 4000;
  const deposito = Math.round((precioCancha + precioArbitro + margen) / 2);

  const handlePagar = () => {
    setPagando(true);
    setTimeout(() => {
      setPagando(false);
      setPagado(true);
      setTimeout(() => onPagar(), 2000);
    }, 2000);
  };

  if (pagado) {
    return (
      <div style={styles.exitoWrap}>
        <div style={styles.exitoIcono}>⚡</div>
        <div style={styles.exitoTitulo}>¡Partido a firme!</div>
        <div style={styles.exitoSub}>
          Ambos equipos recibirán la confirmación en WhatsApp.
          Redirigiendo al Dashboard...
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.titulo}>Depósito de garantía</div>
      <div style={styles.sub}>
        El depósito garantiza que ambos equipos se presentan al partido.
        Se devuelve automáticamente al finalizar el encuentro.
      </div>

      {/* Resumen del partido */}
      <div style={styles.resumenPartido}>
        <div style={styles.resumenRow}>
          <span style={styles.resumenLabel}>Rival</span>
          <span style={styles.resumenVal}>{desafio.rival?.nombre}</span>
        </div>
        <div style={styles.resumenRow}>
          <span style={styles.resumenLabel}>Fecha y hora</span>
          <span style={styles.resumenVal}>{desafio.fecha} · {desafio.hora}</span>
        </div>
        <div style={styles.resumenRow}>
          <span style={styles.resumenLabel}>Recinto</span>
          <span style={styles.resumenVal}>{desafio.recinto?.nombre}</span>
        </div>
        <div style={styles.resumenRow}>
          <span style={styles.resumenLabel}>Cancha</span>
          <span style={styles.resumenVal}>{desafio.cancha?.nombre}</span>
        </div>
        <div style={styles.resumenRow}>
          <span style={styles.resumenLabel}>Árbitro</span>
          <span style={styles.resumenVal}>
            {desafio.conArbitro && desafio.arbitro
              ? desafio.arbitro.nombre
              : 'Sin árbitro'}
          </span>
        </div>
        {servicios?.length > 0 && (
          <div style={styles.resumenRow}>
            <span style={styles.resumenLabel}>Servicios</span>
            <span style={styles.resumenVal}>
              {servicios.join(', ')}
            </span>
          </div>
        )}
      </div>

      {/* Monto del depósito */}
      <div style={styles.depositoCard}>
        <div style={styles.depositoTitle}>Tu depósito</div>
        <div style={styles.depositoNum}>
          ${deposito.toLocaleString('es-CL')}
        </div>
        <div style={styles.depositoSub}>
          Cubre: cancha + árbitro + margen TuRival (÷ 2 equipos)
        </div>
        <div style={styles.depositoDetalle}>
          <div style={styles.detalleRow}>
            <span>Cancha</span>
            <span>${precioCancha.toLocaleString('es-CL')}</span>
          </div>
          {precioArbitro > 0 && (
            <div style={styles.detalleRow}>
              <span>Árbitro</span>
              <span>${precioArbitro.toLocaleString('es-CL')}</span>
            </div>
          )}
          <div style={styles.detalleRow}>
            <span>Margen TuRival</span>
            <span>$4.000</span>
          </div>
          <div style={{
            ...styles.detalleRow,
            fontWeight: 700,
            borderTop: '1px solid rgba(255,255,255,0.1)',
            paddingTop: 8, marginTop: 4,
          }}>
            <span>Tu depósito (50%)</span>
            <span>${deposito.toLocaleString('es-CL')}</span>
          </div>
        </div>
      </div>

      {/* Reglas del depósito */}
      <div style={styles.garantiaWrap}>
        <div style={styles.garantiaItem}>
          <span style={styles.garantiaOk}>✓</span>
          <span>Si ambos equipos llegan → depósito devuelto a ambos</span>
        </div>
        <div style={styles.garantiaItem}>
          <span style={styles.garantiaOk}>✓</span>
          <span>Si el rival no llega → recibes su depósito</span>
        </div>
        <div style={styles.garantiaItem}>
          <span style={styles.garantiaMal}>✗</span>
          <span>Si tú no llegas → pierdes tu depósito y baja tu ELO</span>
        </div>
      </div>

      <div style={styles.botones}>
        <button
          style={styles.btnVolver}
          onClick={onVolver}
          disabled={pagando}
        >
          ← Volver
        </button>
        <button
          style={{
            ...styles.btnPagar,
            opacity: pagando ? 0.7 : 1,
          }}
          onClick={handlePagar}
          disabled={pagando}
        >
          {pagando
            ? 'Procesando...'
            : `Pagar $${deposito.toLocaleString('es-CL')} ⚡`}
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif",
    marginBottom: 20, lineHeight: 1.5,
  },
  resumenPartido: {
    background: '#F4F6FA', borderRadius: 12,
    padding: '14px 16px', marginBottom: 16,
  },
  resumenRow: {
    display: 'flex', justifyContent: 'space-between',
    padding: '5px 0', borderBottom: '1px solid #E8ECF4',
    fontSize: 13, fontFamily: "'Barlow', sans-serif",
  },
  resumenLabel: { color: '#9BA5B7', fontWeight: 600 },
  resumenVal:   { color: '#141922', fontWeight: 500 },
  depositoCard: {
    background: '#0D1117', borderRadius: 14,
    padding: '20px', marginBottom: 16, textAlign: 'center',
  },
  depositoTitle: {
    fontSize: 11, fontWeight: 700,
    color: 'rgba(255,255,255,0.4)',
    textTransform: 'uppercase', letterSpacing: '0.06em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 6,
  },
  depositoNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 44, fontWeight: 800,
    color: 'white', lineHeight: 1, marginBottom: 4,
  },
  depositoSub: {
    fontSize: 12, color: 'rgba(255,255,255,0.4)',
    fontFamily: "'Barlow', sans-serif", marginBottom: 16,
  },
  depositoDetalle: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: 10, padding: '12px 14px', textAlign: 'left',
  },
  detalleRow: {
    display: 'flex', justifyContent: 'space-between',
    fontSize: 12, color: 'rgba(255,255,255,0.6)',
    fontFamily: "'Barlow', sans-serif", padding: '3px 0',
  },
  garantiaWrap: {
    display: 'flex', flexDirection: 'column',
    gap: 8, marginBottom: 20,
  },
  garantiaItem: {
    display: 'flex', alignItems: 'flex-start', gap: 10,
    fontSize: 13, color: '#4A5568',
    fontFamily: "'Barlow', sans-serif",
  },
  garantiaOk:  { color: '#16A34A', fontWeight: 700, flexShrink: 0 },
  garantiaMal: { color: '#EF4444', fontWeight: 700, flexShrink: 0 },
  exitoWrap: {
    textAlign: 'center', padding: '40px 20px',
  },
  exitoIcono: { fontSize: 56, marginBottom: 16 },
  exitoTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: '#141922', marginBottom: 8,
  },
  exitoSub: {
    fontSize: 14, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", lineHeight: 1.6,
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnVolver: {
    padding: '12px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnPagar: {
    padding: '12px', background: '#FF6B1A',
    border: 'none', borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 800,
    color: 'white', cursor: 'pointer',
  },
};